<template>
  <div class="box">
    <div class="up">
      <div class="item bg-color-black">
        <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="chart-line" class="text-icon"></icon>
        </span>
          <div class="d-flex">
            <span class="fs-xl text mx-2">体检次数排行榜</span>
          </div>
        </div>
        <div class="d-flex jc-center body-box">
          <dv-scroll-board class="dv-scr-board" :config="config"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getTimeRanking} from "@/api/area/right1";

export default {
  data() {
    return {
      config: {
        header: ['姓名', '最近时间', '完成次数'],
        data: [
          ['李', '2021-11-04', "<span  class='colorRed'>90</span>"],
          ['李', '2021-11-03', "<span  class='colorRed'>43</span>"],
          ['赵', '2021-11-04', "<span  class='colorRed'>43</span>"],
          ['李', '2021-10-31', "<span  class='colorGrass'>41</span>"],
          ['王', '2021-10-30', "<span  class='colorGrass'>36</span>"],
          ['王', '2021-11-04', "<span  class='colorGrass'>33</span>"],
          ['田', '2021-11-04', "<span  class='colorGrass'>32</span>"],
          ['梁', '2021-10-27', "<span  class='colorGrass'>10</span>"],
          ['姜', '2021-10-13', "<span  class='colorGrass'>8</span>"],
          ['李', '2021-11-01', "<span  class='colorGrass'>4</span>"]
        ],
        rowNum: 5, //表格行数
        headerHeight: 35,
        headerBGC: '#0f1325', //表头
        oddRowBGC: '#0f1325', //奇数行
        evenRowBGC: '#171c33', //偶数行
        index: true,
        columnWidth: [50],
        align: ['center']
      }
    }
  },
  components: {},
  created() {
    this.getData();
  },
  methods: {
    /**
     * 获取数据
     */
    getData() {
      // 体检次数排行榜
      getTimeRanking().then((res) => {
        if (res.code === "0") {
          let ret = [];
          res.data.forEach((item) => {
            ret.push([item.username, item.cstamp, "<span  class='colorRed'>" + item.time + "</span>"],);
          });
          this.config.data = ret;
          this.config = {...this.config}
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/box';

.item {
  width: 100%;
  height: 100%;
}

.text {
  color: #c3cbde;
}

.body-box {
  border-radius: 10px;
  overflow: hidden;

  .dv-scr-board {
    width: 100%;
    height: 200px;
  }
}

</style>
